<div [formGroup]="activitiesForm">
    <div class="form-title-container">
        <h3 class="subtitle">Actividades</h3>
    </div>
    <p-accordion [multiple]="true" formArrayName="activities">
        @for (activity of activities.controls; let i = $index; track activity) {
            <p-accordionTab header="{{activities.at(i).value.acronym ? activities.at(i).value.acronym : 'Nueva actividad' }}" [formGroupName]="i">
                <div class="columns is-multiline">
                    <div class="column is-6 form-container">
                        <p-checkbox formControlName="principal" binary="true" inputId="principal" [readonly]="true" />
                        <label for="principal">Actividad principal</label>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Fecha de alta</span>
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Siglas</span>
                        <input class="search-input" type="text" pInputText formControlName="acronym" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Vía pública</span>
                        <input class="search-input" type="text"  pInputText formControlName="street" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Número de vía</span>
                        <input class="search-input" type="text" pInputText formControlName="number" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Escalera</span>
                        <input class="search-input" type="text" pInputText formControlName="stairs" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Piso</span>
                        <input class="search-input" type="text" pInputText formControlName="floor" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Puerta</span>
                        <input class="search-input" type="text" pInputText formControlName="door" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Municipio</span>
                        <input class="search-input" type="text" pInputText formControlName="town" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">CP</span>
                        <input class="search-input" type="text" pInputText formControlName="postalCode" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Provincia</span>
                        <input class="search-input" type="text" pInputText formControlName="province" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Código país</span>
                        <input class="search-input" type="text" pInputText formControlName="codeCountry" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">País</span>
                        <input class="search-input" type="text" pInputText formControlName="country" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Referencia catastral</span>
                        <input class="search-input" type="text" pInputText formControlName="cadastralReference" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Código CNAE</span>
                        <input class="search-input" type="text" pInputText formControlName="codeCNAE" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Código IAE</span>
                        <input class="search-input" type="text" pInputText formControlName="codeIAE" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Tipo de actividad</span>
                        <p-dropdown [options]=" clientConstants.ACTIVITY_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de actividad" formControlName="type" [readonly]="true"/>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Centro de trabajo</span>
                        <p-dropdown [options]="" optionLabel="label" placeholder="Seleccionar centro de trabajo" formControlName="workCenter" [readonly]="true"/>
                    </div>
                    <div class="column is-12">
                        <h4>Parámetros IAE</h4>
                        <div class="columns is-multiline">
                            <div class="column is-6 form-container">
                                <p-checkbox formControlName="exemptionIAE" binary="true" inputId="exemptionIAE" [readonly]="true" />
                                <label for="exemptionIAE">Exención IAE</label>
                            </div>
                            <div class="column is-6 form-container">
                                <p-checkbox formControlName="startUpExemption" binary="true" inputId="startUpExemption" [readonly]="true"/>
                                <label for="startUpExemption">Exención por inicio</label>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Fecha inicio exención</span>
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startUpExemptionStartDate" [readonlyInput]="true" showOnFocus="false"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Fecha baja exención</span>
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startUpExemptionEndDate" [readonlyInput]="true" showOnFocus="false"/>
                            </div>
                            <div class="column is-6 form-container">
                                <p-checkbox formControlName="turnoverExemption" binary="true" inputId="turnoverExemption" [readonly]="true"/>
                                <label for="turnoverExemption">Exención por cifra negocios</label>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Fecha inicio exención</span>
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="turnoverExemptionStartDate" [readonlyInput]="true" showOnFocus="false" />
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Fecha baja exención</span>
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="turnoverExemptionEndDate" [readonlyInput]="true" showOnFocus="false"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Clase cuota</span>
                                <p-dropdown [options]="clientConstants.QUOTE_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de actividad" formControlName="quoteType" [readonly]="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <h4>Elementos</h4>
                        <div class="columns is-multiline">
                            <div class="column is-6 form-container">
                                <span class="label">Nº Obreros</span>
                                <input class="search-input" type="text" pInputText formControlName="workers" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Potencia (KW)</span>
                                <input class="search-input" type="text" pInputText formControlName="power" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Nº Vehículos</span>
                                <input class="search-input" type="text" pInputText formControlName="vehicles" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Nº Máquinas</span>
                                <input class="search-input" type="text" pInputText formControlName="machines" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Tipo de maquinaria</span>
                                <input class="search-input" type="text" pInputText formControlName="machinesType" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Escaparates</span>
                                <input class="search-input" type="text" pInputText formControlName="showCases" [readonly]="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12">
                        <h4>Superfície</h4>
                        <div class="columns is-multiline">
                            <div class="column is-6 form-container">
                                <span class="label">M2 totales construidos</span>
                                <input class="search-input" type="text" pInputText formControlName="totalBuilt" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">M2 totales útiles</span>
                                <input class="search-input" type="text" pInputText formControlName="totalUseful" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">M2 sin reducción</span>
                                <input class="search-input" type="text" pInputText formControlName="m2WithoutReduction" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">M2 descubiertos</span>
                                <input class="search-input" type="text" pInputText formControlName="m2Uncovered" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">M2 enseñanza</span>
                                <input class="search-input" type="text" pInputText formControlName="m2Teaching" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">M2 almacén</span>
                                <input class="search-input" type="text" pInputText formControlName="m2Store" [readonly]="true"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">M2 aparcamiento cubierto</span>
                                <input class="search-input" type="text" pInputText formControlName="m2CoveredParking" [readonly]="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-6 form-container">
                            <span class="label">Fecha variación actividad</span>
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="activityVariationDate" [readonlyInput]="true" showOnFocus="false"/>
                        </div>
                        <div class="column is-6 form-container">
                            <span class="label">Motivo variación </span>
                            <input class="search-input" type="text" pInputText formControlName="activityVariationReason" [readonly]="true"/>
                        </div>
                    </div>
                    <div class="column is-6 form-container">
                        <span class="label">Fecha de baja</span>
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                    </div>
                </div>
            </p-accordionTab>
        }@empty {
            <span>No hay actividades</span>
        }
    </p-accordion>
</div>
<div [formGroup]="societyForm" [ngStyle]="{'margin-top':'40px', 'margin-bottom':'10px'}">
    <div class="columns is-multiline">
        <div class="column is-12 form-container">
            <p-checkbox formControlName="isBigCompany" binary="true" inputId="isBigCompany" [readonly]="true"/>
            <label for="isBigCompany">Gran empresa</label>
        </div>
        @if (bigCompanyPeriods.length > 0) {
          <div class="column is-12">
            <span class="label">Periodos Gran Empresa:</span>
            <div formArrayName="isBigCompanyPeriods">
              @for (period of bigCompanyPeriods.controls; track $index) {
                <div class="period-readonly" [formGroupName]="$index">
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                  <span> - </span>
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                </div>
              }
            </div>
          </div>
        }

        <div class="column is-6 form-container">
            <span class="label">Fecha alta obligación IS</span>
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startDateISOObligation" [readonlyInput]="true"/>
        </div>
        
        <div class="column is-6 form-container">
            <span class="label">Opción pago fraccionado</span>
            <p-dropdown [options]=" clientConstants.FRACTIONATED_PAYMENT_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de cliente" formControlName="fractionatedPayment" [readonly]="true"/>
        </div>
        <div class="column is-12 form-container">
            <p-checkbox formControlName="paymentOnAccountIS403LIS" binary="true" inputId="paymentOnAccountIS403LIS" [readonly]="true"/>
            <label for="paymentOnAccountIS403LIS">Opción pago a cuenta IS 40.3 LIS</label>
        </div>
        @if (is403LISPeriods.length > 0) {
          <div class="column is-12">
            <span class="label">Periodos IS 40.3 LIS:</span>
            <div formArrayName="paymentOnAccountIS403LISPeriods">
              @for (period of is403LISPeriods.controls; track $index) {
                <div class="period-readonly" [formGroupName]="$index">
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                  <span> - </span>
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                </div>
              }
            </div>
          </div>
        }
    </div>
</div>
<div [formGroup]="otherForm">

    <div class="columns is-multiline ">
        <div class="column is-6 form-container">
            <span class="label">Nombre administración AEAT</span>
            <input class="search-input" type="text" pInputText formControlName="administrationNameAEAT" [readonly]="true"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Código administración AEAT</span>
            <input class="search-input" type="text" pInputText formControlName="administrationCodeAEAT" [readonly]="true"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Delegación AEAT</span>
            <input class="search-input" type="text" pInputText formControlName="delegationAEAT" [readonly]="true"/>
        </div>
        <div class="column is-12 form-container">
            <p-checkbox formControlName="intraCommunityOperatorObligation" binary="true" inputId="intraCommunityOperatorObligation" [readonly]="true"/>
            <label for="intraCommunityOperatorObligation">Operador intracomunitario</label>
        </div>
        @if (roiPeriods.length > 0) {
          <div class="column is-12">
            <span class="label">Periodos ROI:</span>
            <div formArrayName="intraCommunityOperatorPeriods">
              @for (period of roiPeriods.controls; track $index) {
                <div class="period-readonly" [formGroupName]="$index">
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                  <span> - </span>
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                </div>
              }
            </div>
          </div>
        }
        <div class="column is-6 form-container">
            <p-checkbox formControlName="presentationSIIObligation" binary="true" inputId="presentationSIIObligation" [readonly]="true"/>
            <label for="presentationSIIObligation">Obligación presentación SII</label>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Fecha alta SII</span>
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="presentationSIIStartDate" [readonlyInput]="true" showOnFocus="false"/>
        </div>
        <div class="column is-6 form-container">
            <span class="label">Fecha baja SII</span>
            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="presentationSIIEndDate" [readonlyInput]="true" showOnFocus="false"/>
        </div>
        <div class="column is-12 form-container">
            <p-checkbox formControlName="codeEORI" binary="true" inputId="codeEORI" [readonly]="true"/>
            <label for="codeEORI">Código EORI</label>
        </div>
        @if (eoriPeriods.length > 0) {
          <div class="column is-12">
            <span class="label">Periodos EORI:</span>
            <div formArrayName="codeEORIPeriods">
              @for (period of eoriPeriods.controls; track $index) {
                <div class="period-readonly" [formGroupName]="$index">
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                  <span> - </span>
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                </div>
              }
            </div>
          </div>
        }
        <div class="column is-12 form-container">
            <p-checkbox formControlName="isFiscalGroup" binary="true" inputId="isFiscalGroup" [readonly]="true"/>
            <label for="isFiscalGroup">Grupo Fiscal</label>
        </div>
        @if (fiscalGroupPeriods.length > 0) {
          <div class="column is-12">
            <span class="label">Periodos Grupo Fiscal:</span>
            <div formArrayName="fiscalGroupPeriods">
              @for (period of fiscalGroupPeriods.controls; track $index) {
                <div [formGroupName]="$index" class="columns is-multiline" style="margin-bottom: 0.5rem; align-items: center;">
                  <div class="column is-2">
                    <span class="field-label">Fecha alta</span>
                    <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                  </div>
                  <div class="column is-2">
                    <span class="field-label">Fecha baja</span>
                    <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                  </div>
                  <div class="column is-2">
                    <span class="field-label">No Grupo Fiscal</span>
                    <input class="search-input" type="text" pInputText formControlName="taxGroupNumber" [readonly]="true"/>
                  </div>
                  <div class="column is-2">
                    <span class="field-label">Soc. dominante</span>
                    <p-checkbox formControlName="isDominantCompany" binary="true" [inputId]="'isDominantCompany_ro_' + $index" [readonly]="true"/>
                  </div>
                  @if (!period.get('isDominantCompany')?.value) {
                    <div class="column is-4">
                      <span class="field-label">Denominación soc. dominante</span>
                      <input class="search-input" type="text" pInputText formControlName="dominantCompanyName" [readonly]="true"/>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <div class="column is-12 form-container">
            <p-checkbox formControlName="codeLEI" binary="true" inputId="codeLEI" [readonly]="true"/>
            <label for="codeLEI">Código LEI</label>
        </div>
        @if (leiPeriods.length > 0) {
          <div class="column is-12">
            <span class="label">Periodos LEI:</span>
            <div formArrayName="codeLEIPeriods">
              @for (period of leiPeriods.controls; track $index) {
                <div class="period-readonly" [formGroupName]="$index">
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="startDate" [readonlyInput]="true" showOnFocus="false"/>
                  <span> - </span>
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="endDate" [readonlyInput]="true" showOnFocus="false"/>
                </div>
              }
            </div>
          </div>
        }
        @if (isPhysicalPerson) {
          <!-- Persona Física: Checkbox + Fecha de caducidad -->
          <div class="column is-6 form-container">
            <div class="checkbox-label-container">
              <p-checkbox [binary]="true" [(ngModel)]="hasCertificate" [disabled]="true" inputId="digitalCertificate"/>
              <label for="digitalCertificate">Certificado digital</label>
              @if (digitalCertificates.length > 0 && isCertificateExpired(0)) {
                <fa-icon [icon]="faTriangleExclamation" style="color: #ff6b6b; margin-left: 8px;" title="Este certificado ha caducado"></fa-icon>
              }
            </div>
          </div>
          @if (digitalCertificates.length > 0) {
            <div class="column is-6" formArrayName="digitalCertificates">
              @for (cert of digitalCertificates.controls; let i = $index; track i) {
                <div [formGroupName]="i">
                  <span class="label">Fecha caducidad</span>
                  <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="expiryDate" [readonlyInput]="true" showOnFocus="false"/>
                </div>
              }
            </div>
          }
        } @else {
          <!-- Persona Jurídica: Múltiples certificados con todos los campos -->
          <div class="column is-12 form-container">
              <span class="label">Certificados digitales</span>
          </div>
          @if (digitalCertificates.length > 0) {
            <div class="column is-12">
              <div formArrayName="digitalCertificates">
                @for (cert of digitalCertificates.controls; let i = $index; track i) {
                  <div [formGroupName]="i" class="columns is-multiline" style="margin-bottom: 0.5rem;">
                    <div class="column is-4">
                      <span class="label">Representante</span>
                      <input class="search-input" type="text" pInputText formControlName="representative" [readonly]="true" style="text-transform: uppercase;"/>
                    </div>
                    <div class="column is-4">
                      <span class="label">NIF Representante</span>
                      <input class="search-input" type="text" pInputText formControlName="representativeNif" [readonly]="true"/>
                    </div>
                    <div class="column is-4">
                      <span class="label">Fecha caducidad</span>
                      <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" formControlName="expiryDate" [readonlyInput]="true" showOnFocus="false"/>
                    </div>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="column is-12">
              <span>No hay certificados digitales</span>
            </div>
          }
        }
    </div>
</div>
